// extracted by mini-css-extract-plugin
export var input_group = "input_group-gsd";
export var subscribe_form = "subscribe_form-HIf";
export var subscribe_form_dark = "subscribe_form_dark-K5-";
export var subscribe_form_light = "subscribe_form_light-hLG";